module.exports = __webpack_public_path__ + "static/media/description.9da9b070.svg";